import { GetterTree } from 'vuex';
import { ThreadRepositoryState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<ThreadRepositoryState, RootState> = {
    threadRepositories(state) {
        const { threadRepository } = state;
        return threadRepository;
    }
};
